import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const copyButton = (theme: Theme) =>
  css({
    visibility: "hidden",
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
    backgroundColor: theme.system.backgroundBase,
    "&&&:hover": {
      backgroundColor: theme.system.backgroundMuted,
    },
  });

export const container = css({
  position: "relative",
  "&:hover": {
    button: {
      visibility: "visible",
    },
  },
});

export const copyIcon = css({
  position: "relative",
  left: "-3px",
});
